import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { shouldRenewSignedMedia } from '../utils/itemQueryPolicy'

export function useSignedMediaQueryRenewal(queryKey, enabled = true) {
  const queryClient = useQueryClient()
  const keyId = Array.isArray(queryKey) ? queryKey.join('\0') : String(queryKey || '')

  useEffect(() => {
    if (!enabled || !keyId) return undefined
    const key = keyId.split('\0').filter(Boolean)
    const renew = () => {
      if (document.visibilityState !== 'visible') return
      const state = queryClient.getQueryState(key)
      if (shouldRenewSignedMedia(state?.dataUpdatedAt)) {
        queryClient.invalidateQueries({ queryKey: key })
      }
    }
    document.addEventListener('visibilitychange', renew)
    window.addEventListener('focus', renew)
    return () => {
      document.removeEventListener('visibilitychange', renew)
      window.removeEventListener('focus', renew)
    }
  }, [queryClient, keyId, enabled])
}
